export default {
  inserted(el, binding, vnode) {
    el.addEventListener('compositionend', (e) => {
      // e.target.value = e.target.value.toUpperCase()
      vnode.componentInstance.$emit('input', e.target.value.toUpperCase())
    })
    el.addEventListener('input', (e) => {
      // e.target.value = e.target.value.toUpperCase()
      if (!e.isComposing) { vnode.componentInstance.$emit('input', e.target.value.toUpperCase()) }
    })
  }
}
